import { render, staticRenderFns } from "./MatchText.vue?vue&type=template&id=41cea45f&"
import script from "./MatchText.vue?vue&type=script&lang=js&"
export * from "./MatchText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports